import { twMerge } from 'tailwind-merge'

type Props = {
} & ((React.ComponentPropsWithoutRef<'span'>))

export function Bullet({ className }: Props) {
  className = twMerge(
    'text-zinc-400 dark:text-zinc-600',
    className,
  )

  return (
    <span className={className}>&#8226;</span>
  )
}

